import { Injectable } from "@angular/core";
import { Setting } from "../setting";
import { BaseService } from "./base.services";
import { LoginModel } from "../model/login-model";
import { UserService } from "./user.service";
import { SignUp } from "../model/sign-up.model";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(
    public setting: Setting,
    public baseService: BaseService<any>,
    public userService: UserService
  ) {}

  login(user: LoginModel ): Promise<any> {
    let promesa = new Promise((resolve, reject) => {
      this.baseService.post(this.setting.Endpoint.Login, user).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (error) => {
          reject(error);
        }
      });
    });

    return promesa;
  }

  signUp(user: SignUp ): Promise<any> {
    let promesa = new Promise((resolve, reject) => {
      this.baseService.post(`${this.setting.Endpoint.Users}/without-organization`, user).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (error) => {
          reject(error);
        }
      });
    });

    return promesa;
  }

  sendEmail(email: string): Promise<any> {
    let promesa = new Promise((resolve, reject) => {
      this.baseService
        .post("/v1/users/forgot-password", { email: email })
        .subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error.error.message);
          }
        );
    });

    return promesa;
  }

  verifyCode(email: string, code: string): Promise<any> {
    let promesa = new Promise((resolve, reject) => {
      this.baseService
        .post("/v1/users/validate-code", { email: email, code: code })
        .subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error.error.message);
          }
        );
    });

    return promesa;
  }

  changePassword(
    email: string,
    code: string,
    newPassword: string
  ): Promise<any> {
    const body = {
      email: email,
      code: code,
      password: newPassword,
    };
    console.log(body);
    let promesa = new Promise((resolve, reject) => {
      this.baseService.post("/v1/users/reset-password", body).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error.error.message);
        }
      );
    });

    return promesa;
  }
}
